import styled from 'styled-components'

export const Stamp = styled.div`
    align-items: center;
    background-color: #269957;
    border-radius: 11px;
    color: #fff;
    display: flex;
    font-size: 10px;
    font-weight: 500;
    height: 20px;
    justify-content: center;
    padding: 0 8px;
`
